import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MyMbtiHostQuizReport } from 'src/app/interfaces/mbti'
import { MbtiService } from 'src/app/services/mbti/mbti.service'

@Component({
  selector: 'mbti-select',
  templateUrl: './mbti-select.component.html',
  styleUrls: ['./mbti-select.component.scss'],
})
export class MbtiSelectComponent implements OnInit {
  constructor(private mbtiService: MbtiService) {}

  mbtiList: MyMbtiHostQuizReport[] = []
  selectedItem: MyMbtiHostQuizReport | undefined
  private cursor: string | null | undefined
  private isLoading = false
  @Input() title: string | undefined
  @Input() description: string | undefined
  @Input() showTitle = true
  @Input() showDescription = true
  @Input() showDetailNavigation = false
  @Output() onClickMbtiCard = new EventEmitter<MyMbtiHostQuizReport>()
  @Output() onClickCreateNewMbtiQuiz = new EventEmitter<void>()
  @Output() onClickNavToDetail = new EventEmitter<MyMbtiHostQuizReport>()
  @Output() onSumbit = new EventEmitter<MyMbtiHostQuizReport>()

  ngOnInit() {
    this.mbtiList = []
    this.cursor = undefined
    this.loadMbtiQuizList()
  }

  onClickCard(item: MyMbtiHostQuizReport): void {
    this.selectedItem = item
    this.onClickMbtiCard.emit(item)
  }
  onClickCreateNew(): void {
    this.onClickCreateNewMbtiQuiz.emit()
  }

  async onClickNext(): Promise<void> {
    if (this.selectedItem === undefined) return
    this.onSumbit.emit(this.selectedItem)
  }

  loadMbtiQuizList($event?: any): void {
    if (this.cursor === null || this.isLoading) {
      if (this.cursor === null) {
        $event?.target?.complete?.()
      }
      return
    }
    this.isLoading = true
    this.mbtiService.getMyMbtiHostQuizReportList(this.cursor ?? null, 10).subscribe(
      (res) => {
        this.mbtiList.push(...res.data)
        if (this.cursor === undefined && this.mbtiList.length > 0) {
          this.selectedItem = this.mbtiList[0]
        }
        this.cursor = res.cursor ?? null
        this.isLoading = false
        $event?.target?.complete?.()
      },
      (error) => {
        this.isLoading = false
        console.error(error)
        $event?.target?.complete?.()
      }
    )
  }

  onClickNavigateToDetail(item: MyMbtiHostQuizReport): void {
    this.onClickNavToDetail.emit(item)
  }
}
